const enCommon = {
    // Actions and words that show up on more than one screen
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    close: "Close",
    clear: "Clear",
    retry: "Try again",
    signIn: "Sign in",
    signOut: "Sign out",
    createAccount: "Create account",
    unknownErrorMessage: "Something went wrong, please try again",
    languageLabel: "Language",
    languageFrench: "Français",
    languageEnglish: "English",

    // Error pages
    notFoundTitle: "Page not found",
    notFoundDescription: "This page does not exist or has been moved. Check the address, or head back to the home page.",
    serverErrorTitle: "Something went wrong",
    serverErrorDescription: "An unexpected error stopped this page from loading. Reload it, and if it keeps happening, try again later.",
    reloadPage: "Reload",
    backHome: "Back to home",

    // Navigation
    navMatches: "Matches",
    navCompetitions: "Competitions",
    navHistory: "History",
    navPricing: "Plans",

    // Competitions screen
    competitionsTitle: "Competitions",
    competitionsSubtitle: "Pick a competition and analyse any match it has coming up",
    competitionToBrowse: "Competition to browse",
    popularCompetitions: "Popular competitions",
    loadingCompetitions: "Loading competitions",
    backToCompetition: "Back to the competition",
    navAnalysisSection: "ANALYSIS",
    sidebarTodayAnalysis: "Today's analyses",
    sidebarLimitReached: "Limit reached • Upgrade for more",
    sidebarLeftToday: "{{count}} left today",
    sidebarNoPlan: "No active plan"
}

export default enCommon
